import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TicketLineModel } from './ticketline.model';
import { ConceptModel } from '../../concept/concept/concept.model';
import { TicketTaxModel } from './tickettax.model';
import { ConceptService } from '../../concept/concept/concept.service';
import { map, Observable } from 'rxjs';
import { TaxCalculator } from '../../../shared/taxCalculator';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ConceptSerialNumberComponent } from '../../concept/concept/serialNumber/concept-serialNumber.component';
import { BarcodeDialogComponent } from '../preinvoice/barcode-dialog.component';

@Component({
    selector: 'convfact-ticket-form-item',
    templateUrl: './ticket-form-item.component.html',
    styleUrls: ['./ticket.component.css'],
    standalone: false
})

export class TicketFormItemComponent implements OnInit {
  @Input() item = new TicketLineModel();
  @Input() taxes = Array<TicketTaxModel>();
  @Input() concepts = Array<ConceptModel>();
  chipsArray: [{}];

  conceptCtrl: UntypedFormControl;
  filteredConcepts: Observable<ConceptModel[]>;

  constructor(private conceptService: ConceptService,
    public dialogRef: MatDialogRef<TicketFormItemComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private taxCalculator: TaxCalculator,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,) {
  }

  //Detectar código de barras en campo Concepto
  onConceptEnter(code: string) {
    this.conceptService.barcode(code).then(result => {
      if (result) {
        this.item.product = result.name;
        this.item.conceptUid = result.uid;
        this.item.quantity = 1;
        this.item.unityAmount = result.netPrice - (result.netPrice * (result.discount / 100));
        this.item.taxes = result.taxes;
        this.item.discount = 0;
      } else {
        alert('No se encontró concepto para el código: ' + code);
      }
    });
  }
  //------------------------------------------

  toZero() {
    this.item.unityAmount = null;
  }

  filterConcepts(val) {
    const self = this;

    const concept = this.concepts.find(c => c.name === val);

    if (concept) {
      self.item.conceptUid = concept.uid;
      self.item.quantity = 1;
      self.item.unityAmount = concept.netPrice - (concept.netPrice * (concept.discount / 100));
      self.item.taxes = concept.taxes;
      self.item.discount = 0;
    }

    return val ? this.concepts.filter(s => s.shortcut.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.concepts;
  }

  ngOnInit() {
    this.conceptService.getList().then(
      concepts => {
        this.concepts = concepts;
      }
    )

    this.conceptCtrl = new UntypedFormControl();
    this.filteredConcepts = this.conceptCtrl.valueChanges
      .pipe(
        map(concept => concept && typeof concept === 'object' ? concept.shortcut : concept),
        map(name => this.filterConcepts(name))
      );

    this.taxes = this.data.taxes || [];

    const indexes = [];

    for (let i = 0; i < this.data.item.taxes.length; i++) {
      if (this.data.item.taxes[i] == null) {
        indexes.push(i);
      }
    }

    for (let j = 0; j < indexes.length; j++) {
      this.data.item.taxes.splice(j, 1);
    }

    // Añadimos la linea basica que nos llega, pero sin añadirle los impuestos
    this.item = {
      product: this.data.item.product,
      conceptUid: this.data.item.conceptUid,
      quantity: this.data.item.quantity,
      discount: this.data.item.discount,
      unityAmount: this.data.item.unityAmount,
      position: this.data.item.position,
      totalLine: this.data.item.totalLine,
      taxes: new Array<TicketTaxModel>(),
    };

    // Añadimos los impuestos que tenemos que añadir, usando el metodo correspondiente que incluye la logica necesaria
    for (let i = 0; i < this.data.item.taxes.length; i++) {
      this.setTax(this.data.item.taxes[i], this.item);
    }

  }

  onSelectTax(taxId: number): void {
    const taxFinded = this.taxes.find(c => c.id == taxId);

    if (taxFinded) {
      this.setTax(taxFinded, this.item)
    }

  }

  setTax(tax: TicketTaxModel, item: TicketLineModel): void {
    tax.taxId = tax.id;

    const alreadyApplied = item.taxes.some(t => t.id === tax.id);
    if (alreadyApplied) {
      this.displayInfo('Este impuesto ya ha sido aplicado.');
      return;
    }

    const isRecargoEquiv = tax.name.toLowerCase().includes('recargo equiv');
    const impuestosDelMismoTipo = item.taxes.filter(t => t.type === tax.type && !t.name.toLowerCase().includes('recargo equiv'));

    // Si ya hay un impuesto principal del mismo tipo, no permitir otro
    if (!isRecargoEquiv && impuestosDelMismoTipo.length > 0) {
      this.displayInfo(`Ya se ha aplicado un impuesto del tipo ${tax.type}.`);
      return;
    }

    item.taxes.push(tax);
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 3000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  changeChips = function (element: TicketFormItemComponent) {
    element.item.taxes.forEach(tax => {
      element.setTax(tax, element.item);
    });
  }

  calcularTotalesLinea(invoiceLine) {
    invoiceLine.totalLine = this.taxCalculator.calcularTotalLinea(invoiceLine);
    return invoiceLine.totalLine;
  }

  onCancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }

  onSave(): void {
    this.dialogRef.close({ action: 'save', item: this.item });
  }

  onSelectConcept(concept: ConceptModel): void {
    if (concept) {
      this.item.conceptUid = concept.uid;
      this.item.quantity = 1;
      this.item.unityAmount = concept.netPrice - (concept.netPrice * (concept.discount / 100));
      this.item.taxes = concept.taxes;
      this.item.product = concept.name;

      if (concept.serialNumber) {
        const dialogRef = this.dialog.open(ConceptSerialNumberComponent, {
          width: '640px',
          maxWidth: '96vw',
          height: '70%',
          data: {
            concept: concept,
            live: true
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.item.product = this.item.product + " - S/N: " + result;
          }
        });
      }

      if (concept.discount != null && concept.discount > 0) {
        this.item.product = concept.name + " - " + concept.discount + "% descuento (aplicado a " + concept.netPrice + ")";
      }
    }
  }

  barcode() {
    this.dialog.open(BarcodeDialogComponent, {
    })
      .afterClosed().subscribe(result => {
        const data = result['concept'];
        if (data.uid !== "00000000-0000-0000-0000-000000000000") {
          this.item.conceptUid = data.uid;
          this.item.product = data.name;
          this.item.taxes = data.taxes;
          this.item.unityAmount = data.netPrice;
          if (data['serialNumber']) {
            const dialogRef = this.dialog.open(ConceptSerialNumberComponent, {
              width: '640px',
              maxWidth: '96vw',
              height: '70%',
              data: {
                concept: data,
                live: true
              }
            });
            dialogRef.afterClosed().subscribe(result => {
              if (result) {
                this.item.product = this.item.product + " - S/N: " + result;
              }
            });
          }
        }

      });
  }

  // @Input() item = new TicketLineModel();
  // @Input() taxes = Array<TicketTaxModel>();
  // @Input() concepts = Array<ConceptModel>();
  // chipsArray: [{}];

  // conceptCtrl: FormControl;
  // filteredConcepts: Observable<ConceptModel[]>;

  // constructor(private conceptService: ConceptService,
  //   private taxCalculator: TaxCalculator,
  //   public snackBar: MatSnackBar,) { }

  // toZero() {
  //   this.item.unityAmount = null;
  // }

  // filterConcepts(val) {
  //   let self = this;
  //   for (let concept of this.concepts) {
  //     if (concept.name == val) {
  //       self.item.conceptUid = concept.uid;
  //       self.item.quantity = 1;
  //       self.item.unityAmount = concept.netPrice;
  //       self.item.taxes = concept.taxes;
  //       self.item.discount = 0;
  //     }
  //   }

  //   const normalizedValue = this.normalize(val);
  //   return val ? this.concepts.filter(concept => this.normalize(concept.shortcut).includes(normalizedValue)) : this.concepts;
  // }

  // // Normaliza la cadena eliminando diacríticos y convirtiéndola a minúsculas
  // // NFD Descompone la consonante por ejemplo ñ -> n -> ~
  // private normalize(str: string): string {
  //   return str.normalize('NFD').replace(/[\u0300\u0301\u0303\u0327\u0308]/g, '').toLowerCase();
  // }


  // ngOnInit() {
  //   this.conceptService.getList().then(
  //     concepts => {
  //       this.concepts = concepts;
  //     }
  //   )
  //   this.conceptCtrl = new FormControl();
  //   this.filteredConcepts = this.conceptCtrl.valueChanges
  //     .map(concept => concept && typeof concept === 'object' ? concept.shortcut : concept)
  //     .map(name => this.filterConcepts(name));

  // }



  // displayFn(concept) {
  //   for (let ct of this.concepts) {
  //     if (ct.name == concept) {
  //       this.item.quantity = 1;
  //       this.item.unityAmount = ct.price;
  //     }
  //   }
  // }

  // setTax = function (tax: TicketTaxModel, item: TicketLineModel) {

  //   tax.taxId = tax.id;

  //   if (item.taxes.filter(t => t.type == tax.type).length === 0) {

  //     item.taxes.push(tax);

  //   } else {

  //     if (tax.name.includes("Inversión S.P.") && item.taxes.filter(t => t.name.includes("Inversión S.P.")).length === 0) {

  //       item.taxes.push(tax);

  //     } else if (item.taxes.filter(t => t.name.includes("Inversión S.P.")).length !== 0 && tax.name.includes("Inversión S.P.") === false) {

  //       item.taxes.push(tax);

  //     } else {

  //       this.displayInfo('No se puede añadir impuestos del mismo tipo');

  //     }

  //   }

  // }

  // displayInfo(message: string): void {
  //   let options = new MatSnackBarConfig();
  //   options.duration = 3000;
  //   options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  // }

  // changeChips = function (element: TicketFormItemComponent) {
  //   element.item.taxes.forEach(tax => {
  //     element.setTax(tax, element.item);
  //   });
  // }




  public trackByIndex(i: number) { return i; }

}
